import {useTranslation} from "react-i18next";
import labelsDefault from "./labelsDefault";
import OrderByHeaders from "components/ordering/OrderByHeaders";
import {ContainerSVG} from "components/waste-icons/svgs/ContainerSVG";

const TableIsland = ({itemsShow, items, checkAll, setCheckAll, buttonsTB, setButtonsTB, orderingRef}) => {
    const [t] = useTranslation("tables");
    const labels = labelsDefault;

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length !== 1;
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "164px",
        backgroundColor: "white",
        zIndex: 799,
    };

    return (
        <table className="table-islands table table-striped sticky-horizontal">
            <thead>
                <tr>
                    <th
                        style={{
                            width: "0.4%",
                            ...stickyHeaderStyle,
                        }}
                        className="sticky-top border-bottom-sticky">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} styleHeaders={stickyHeaderStyle} />
                </tr>
            </thead>
            <tbody>
                {itemsShow.length ? (
                    itemsShow.map((item) => (
                        <tr key={item.id} data-idx={item.id} onClick={onClick}>
                            <td>
                                <input
                                    type="checkbox"
                                    name="checkboxContainer"
                                    key={item.id}
                                    data-idx={item.id}
                                    defaultChecked={items.current.chosen.includes(item.id)}
                                    readOnly={true}
                                />
                            </td>
                            <td>{item.name}</td>
                            <td>
                                <div className="d-flex flex-row">
                                    {item.actives.map((active, idx) => (
                                        <div key={idx} className="waste-icon me-2" title={labels[active.waste_type]}>
                                            <ContainerSVG type={active.waste_type} width="20px" height="20px" />
                                        </div>
                                    ))}
                                </div>
                            </td>
                            <td>{item.counter}</td>
                            <td>{item.zone_name}</td>
                        </tr>
                    ))
                ) : (
                    <></>
                )}
            </tbody>
        </table>
    );
};

export default TableIsland;
